import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { grey, info, success, error, warning } from '../neutral/colors.js';
export { error, grey, info, success, warning } from '../neutral/colors.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var primary = {
  primary: '#00aa46',
  primary900: '#005a13',
  primary800: '#007827',
  primary700: '#008932',
  primary600: '#009b3e',
  primary500: '#00aa46',
  primary400: '#45dc77',
  primary300: '#70f682',
  primary200: '#95d4a3',
  primary100: '#bfe5c7',
  primary50: '#e4f5e8'
};
var secondary = {
  secondary: '#ffaa00',
  secondary900: '#fe7f00',
  secondary800: '#ffaa00',
  secondary700: '#ffc30f',
  secondary600: '#ffdc1c',
  secondary500: '#f8e814',
  secondary400: '#fbed46',
  secondary300: '#fdf16b',
  secondary200: '#fef697',
  secondary100: '#fffac1',
  secondary50: '#fffee6'
};
var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grey), primary), secondary), info), success), error), warning);

export { colors, primary, secondary };
//# sourceMappingURL=colors.js.map
